import { render, staticRenderFns } from "./task_menu.vue?vue&type=template&id=942fac4e&scoped=true"
import script from "./task_menu.vue?vue&type=script&lang=js"
export * from "./task_menu.vue?vue&type=script&lang=js"
import style0 from "./task_menu.vue?vue&type=style&index=0&id=942fac4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942fac4e",
  null
  
)

export default component.exports